import styled from "styled-components";
import { BLUE_RGB } from "utils/colorsTheme";

const TitleModalStyled = styled.h4`
  margin: 0;
  line-height: 1.42857143;
  font-weight: bold;
  color: ${(props) => (props.color ? `${props.color}` : BLUE_RGB)};
`;
const SubtitleModalStyled = styled.span`
  word-wrap: break-word;
`;

const DetailListStyled = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const ComboRowStyled = styled.div`
  display: flex;
  flex-direction: ${(props) =>
    props.direction ? `${props.direction}` : "row"};
`;
const InputContainer = styled.div`
  margin: 0 0.3rem;
  width: 100%;
`;

const MapContainer = styled.div`
  width: 550px;
  height: 250px;
`;
const ImageRowStyled = styled.div`
  margin: 0.5rem 0 0;
  display: flex;
  justify-content: center;
`;
const ImageContainerStyled = styled.div`
  width: 180px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.3rem;
  flex-direction: column;
`;
const ImageStyled = styled.img`
  max-width: 160px;
  max-height: 160px;
  border-radius: 1rem;
  object-fit: fill;
`;
const ImageTitleStyled = styled.span`
  margin-bottom: 0.2rem;
`;

export {
  InputContainer,
  MapContainer,
  TitleModalStyled,
  ComboRowStyled,
  SubtitleModalStyled,
  DetailListStyled,
  ImageContainerStyled,
  ImageStyled,
  ImageRowStyled,
  ImageTitleStyled,
};
